<template>
  <div class="allTabs mt-10">
    <v-row dense>
      <v-col cols="7" sm="9" md="10">
        <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search with trading account ..." single-line
          solo hide-details class="input-search"></v-text-field>
      </v-col>
      <v-col cols="5" sm="3" md="2">
        <v-select v-model="selectedAccountNo" solo :items="accountNumbers" append-icon="mdi-chevron-down"
          label="Account No" class="custom-select"></v-select>
      </v-col>
    </v-row>
    <v-row dense class="mt-2">
      <v-skeleton-loader v-if="loading" type="card" class="mt-5" :loading="true" width="400"></v-skeleton-loader>
      <v-col md="6" sm="6" lg="4" v-for="(account, index) in filteredAccounts" :key="index" v-if="!loading">
        <v-card class="elevation-0 rounded-0 live-account-card" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
          <v-card-actions>
            <div class="trade-status">
              <div v-if="account?.trader_type === 1">
                  <v-icon color="#647E98">
                   mdi-chart-timeline-variant
                  </v-icon>
              </div>
              <div v-else-if="account?.trader_type === 2">
                <v-icon color="#647E98">
                   mdi-chart-bell-curve-cumulative
                  </v-icon>
              </div>
              <div v-else>
                <v-icon color="#647E98">
                  {{ account?.is_live === 1 ? "mdi-signal" : "mdi-arrow-top-left" }}
                </v-icon>
              </div>
              <div class="trade-number">
                <span :class="account?.is_live === 1 ? 'text-green' : 'text-red'">
                  {{ account?.is_live === 1 ? "MT5" : "Demo" }} -
                  {{ account?.account_type_display || account?.tradingaccounttypes?.account_type_display }}
                  ({{ getTraderTypeName(account?.trader_type) }})
                </span>
                <span>
                  {{ account?.trading_account_no }}
                  <span v-if="account?.manager_account" class="text-ms">
                    ( Manager : {{ account?.st_username }} )
                  </span>
                </span>
              </div>
            </div>
            <v-spacer></v-spacer>
            <div class="trade-dropdown">
              <v-menu rounded="0" class="trade-dropdown-menu" transition="slide-x-transition" bottom left>
                <template v-slot:activator="{ attrs, on }">
                  <v-btn small tile elevation="0" class="ma-0 text-capitalize btn-account" v-bind="attrs" v-on="on"
                    icon>
                    <v-icon :color="$vuetify.theme.dark ? '#fff' : '#162334'">mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-card class="dropdown-menu-card" tile flat>
                  <v-list flat outlined :color="$vuetify.theme.dark ? '#111A26' : '#F1F7FB'">
                    <v-list-item-group>
                      <v-list-item v-for="(item, i) in items" :key="i" :ripple="false" link>
                        <v-list-item-content>
                          <router-link v-text="item.text" class="text-decoration-none" router :to="{
                            path: item.link,
                            query: {
                              id: account?.id,
                              ...((item.text === 'Change Leverage' || item.text === 'Change Trading Password') && { account: account?.trading_account_no }),
                            },
                          }"></router-link>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-menu>
            </div>
          </v-card-actions>
          <v-card-actions>
            <div class="value-trades mb-0">
              <span>Balance</span>
              <span>{{ account?.Balance.toFixed(2) }} $</span>
            </div>
            <v-spacer></v-spacer>
            <div class="value-trades mb-0">
              <span>Mt5 Currency</span>
              <span>{{ account?.currency_name }}</span>
            </div>
          </v-card-actions>
          <v-card-actions>
            <v-sheet :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'">
              <div>
                <apexChart width="100%" height="85px" type="line" :options="options" :series="[
                  { name: 'Equity/Balance', data: seriesData(account) },
                ]"></apexChart>
              </div>
            </v-sheet>
          </v-card-actions>
          <v-card-actions>
            <div class="currency-leverage">
              <span>Equity</span>
              <span>{{ account?.Equity?.toFixed(2) }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="currency-leverage">
              <span>Leverage</span>
              <span>{{ account?.leverage }}</span>
            </div>
          </v-card-actions>
          <v-card-actions>
            <div class="balance-equity">
              <span>Free Margin</span>
              <span>{{ account?.MarginFree.toFixed(2) }}</span>
            </div>
            <v-spacer></v-spacer>
            <div class="balance-equity text-right">
              <span>Acc. Type</span>
              <span>{{ account?.account_type_display }}</span>
            </div>
          </v-card-actions>
          <v-card-actions class="pb-0">
            <v-btn :disabled="account?.is_live===0" :to="{
              path:
                account?.trader_type === 1
                  ? 'manage-investors-account-details'
                  : account?.is_live === 0
                    ? 'demo-account-details'
                    : 'trading-account-details',
              query: { id: account?.id },
            }" block outlined class="blink">
              See Details
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col md="12" sm="12">
        <p class="text-center" v-if="!filteredAccounts.length">No Account found</p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  TRADING__ACTIONS,
  MAM__ACTIONS,
} from "@/store/action-types";

export default {
  data() {
    return {
      search: "",
      loading:false,
      selectedAccountNo: "All",
      slots: ["USD", "INR", "JPY"],
      items: [
        { text: "Deposit Funds", link: "/deposit" },
        { text: "Withdraw Funds", link: "/withdraw" },
        { text: "Internal Transfer", link: "/internal-transfer" },
        { text: "Change Trading Password", link: "/change-mt5-password" },
        { text: "Change Leverage", link: "/change-leverage" },
        { text: "Account Detail", link: "/trading-account-details" },
      ],
      options: {
        chart: {
          type: "line",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          labels: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        grid: {
          show: false,
        },
        stroke: {
          width: 2,
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#3A648E"],
      },
    };
  },
  computed: {
    ...mapState("trading", ["demoAccounts", "liveTradingAccounts"]),
    ...mapState("mam", ["myInvestorAccounts", "myManagerAccounts"]),

    combinedAccounts() {
      const allAccounts = [];
      if (this.demoAccounts) {
        allAccounts.push(...this.demoAccounts);
      }
      if (this.liveTradingAccounts) {
        allAccounts.push(...this.liveTradingAccounts);
      }
      if (this.myInvestorAccounts) {
        allAccounts.push(...this.myInvestorAccounts);
      }
      if (this.myManagerAccounts) {
        allAccounts.push(...this.myManagerAccounts);
      }
      return allAccounts;
    },

    filteredAccounts() {
      return this.combinedAccounts.filter((account) => {
        const matchesSearch = Object.values(account).some(value =>
          String(value).toLowerCase().includes(this.search.toLowerCase())
        );
        const matchesAccountNo = this.selectedAccountNo === "All" || account.trading_account_no === this.selectedAccountNo;
        return matchesSearch && matchesAccountNo;
      });
    },

    accountNumbers() {
      const uniqueAccountNumbers = [...new Set(this.combinedAccounts.map(account => account.trading_account_no))];
      return ["All", ...uniqueAccountNumbers];
    },
  },
  methods: {
    ...mapActions("trading", [
      TRADING__ACTIONS.DEMOACCOUNTS,
      TRADING__ACTIONS.LIVETRADINGACCOUNTS,
    ]),
    ...mapActions("mam", [
      MAM__ACTIONS.MYINVESTORACCOUNTS,
      MAM__ACTIONS.MYMANAGERACCOUNTS,
    ]),
    getTraderTypeName(type) {
    switch (type) {
      case 0: return "Live Acc.";
      case 1: return "Manager";
      case 2: return "Investor";
      case 3: return "IB";
      case 4: return "Prop Trading";
      case 5: return "Contest";
      default: return "Unknown";
    }
  },
    seriesData(acc) {
      const balance = Number(acc?.Balance) || 0;
      const equity = Number(acc?.Equity) || 0;

      if (balance > equity) {
        return [50, 20, 15, 10, -10, -15, -20];
      } else if (balance < equity) {
        return [-20, -15, -10, 10, 15, 20, 50];
      } else if (balance === equity) {
        return [45, 47, 43, 45, 43, 47, 45];
      } else {
        return [0, 0];
      }
    },
  },

  async mounted() {
    this.loading = true;
    try {
      await this.DEMOACCOUNTS();
      await this.LIVETRADINGACCOUNTS();
      await this.MYINVESTORACCOUNTS();
      await this.MYMANAGERACCOUNTS();
    } catch (error) {
      console.error("Error fetching accounts:", error);
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style>
.text-ms{
  font-weight: 300 !important;
  font-size: 12px !important;
}
</style>
 
